// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1_RAw","cls2":"FocusedNav-cls2_EEm FocusedNav-cls1_RAw","inDevStyle":"FocusedNav-inDevStyle_a1y","useGrid":"FocusedNav-useGrid_Vl7"};